<template>
  <span class="inline-flex">
    <!-- tao moi -->
    <i
      v-if="status == APPROVE_STATUS.CHUA_PHE_DUYET"
      class="font-size__medium fas fa-file-plus color__yellow icon-status "
    ></i>
    <!-- dang trinh ky -->
    <i
      v-if="status == APPROVE_STATUS.TAM_PHE_DUYET"
      class="font-size__medium fas fa-play-circle color__blue icon-status"
    ></i>
    <!-- Cho ban hanh -->
    <i
      v-if="status == APPROVE_STATUS.DA_BAN_HANH"
      class="font-size__medium fas fa-user-edit color__green icon-status "
    ></i>
    <!-- Tu choi -->
    <i
      v-if="status == APPROVE_STATUS.HUY_YEU_CAU"
      class="font-size__medium fas fa-times-circle color__red icon-status"
    ></i>
    <!-- Tu choi -->
    <i
      v-if="status == APPROVE_STATUS.KHONG_PHE_DUYET"
      class="font-size__medium fas fa-times-circle color__red icon-status"
    ></i>
  </span>
</template>


<script>
import constants from "../../constants";

export default {
  name: 'filterIconByStatus',
  props: ['status'],

  data () {
    return {
      APPROVE_STATUS : constants.HC_CALENDAR.APPROVE_STATUS
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/filterIconStatusLT.vue